import CancelLink from '../CancelLink';
import CancelPlan from '../CancelPlan';
import ChangePlanLink from '../ChangePlanLink';
import { Auth0UserInfo } from '@lib/auth0/utils';
import { H1 } from '@components/atoms/typography';

export type Membership = {
  title: string;
  id: number;
};

type ChangePlanProps = {
  hasPaidSubscription: boolean;
  isAppSubscription: boolean;
  hasRecurringSubscription: boolean;
  setIsCancelPlanOpen: (boolean) => void;
  initChurnkey?: () => void;
  nextPaymentDate?: string;
  nextPaymentAmount?: string;
  isCancelPlanOpen: boolean;
  isStripeMember: boolean;
  user: Auth0UserInfo;
};

const ChangePlan = ({
  hasPaidSubscription,
  isAppSubscription,
  hasRecurringSubscription,
  nextPaymentDate,
  nextPaymentAmount,
  setIsCancelPlanOpen,
  initChurnkey,
  isCancelPlanOpen,
  isStripeMember,
  user
}: ChangePlanProps) => {
  if (!hasPaidSubscription) {
    return (
      <div className="p-6 min-w-90 md:min-w-60 xl:min-w-50 md:min-h-20 max-h-screen">
        <div className="flex justify-between">
          <H1>Subscription</H1>
        </div>
        <div className="max-h-80vh overflow-y-auto mt-6">
          <div className="px-8 leading-relaxed">
            <div className="sm:flex sm:justify-between my-1">
              <span className="hidden sm:block">Sign Up (Free)</span>
              <span className="font-semibold flex justify-center sm:block my-1 sm:my-0">
                Sign Up (Free)
              </span>
            </div>
            <div className="flex items-center flex-col-reverse sm:flex-row sm:justify-between my-6">
              <CancelLink
                isAppSubscription={isAppSubscription}
                isStripeMember={isStripeMember}
                setIsCancelPlanOpen={(value) => setIsCancelPlanOpen(value)}
                initChurnkey={() => initChurnkey && initChurnkey()}
              />
              <div>
                <ChangePlanLink isAppSubscription={isAppSubscription} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 min-w-90 md:min-w-60 xl:min-w-50 md:min-h-20 max-h-screen">
      <div className="flex justify-between">
        <H1>Subscription</H1>
      </div>
      <div className="max-h-80vh overflow-y-auto mt-6">
        {isCancelPlanOpen ? (
          <CancelPlan
            setIsCancelPlanOpen={(value) => setIsCancelPlanOpen(value)}
            user={user}
          />
        ) : hasRecurringSubscription ? (
          <div className="px-8 leading-relaxed">
            <div className="sm:flex sm:justify-between my-1">
              <span className="hidden sm:block">Plan</span>
              <span className="font-semibold flex justify-center sm:block my-1 sm:my-0">
                {user?.['https://fantasyfootballhub.co.uk/roles']?.[0]}
              </span>
            </div>
            <div className="flex justify-center sm:justify-between my-1">
              <span>Next Billing Date</span>
              <span className="sm:hidden">:</span>
              <span className="font-semibold ml-1 sm:ml-0">
                {nextPaymentDate}
              </span>
            </div>
            <div className="flex justify-center sm:justify-between my-1">
              <span>Payment Amount</span>
              <span className="sm:hidden">:</span>
              {nextPaymentAmount && (
                <span className="font-semibold ml-1 sm:ml-0">
                  £{nextPaymentAmount}
                </span>
              )}
            </div>
            <div className="flex items-center flex-col-reverse sm:flex-row sm:justify-between my-6">
              <CancelLink
                isAppSubscription={isAppSubscription}
                isStripeMember={isStripeMember}
                setIsCancelPlanOpen={(value) => setIsCancelPlanOpen(value)}
                initChurnkey={() => initChurnkey && initChurnkey()}
              />
              <div>
                <ChangePlanLink isAppSubscription={isAppSubscription} />
              </div>
            </div>
          </div>
        ) : (
          <div className="px-8 leading-relaxed">
            <div className="sm:flex sm:justify-between my-1">
              <span className="hidden sm:block">Plan</span>
              <span className="font-semibold flex justify-center sm:block my-1 sm:my-0">
                {user?.['https://fantasyfootballhub.co.uk/roles']?.[0]}
              </span>
            </div>
            <div className="flex justify-center sm:justify-between my-1">
              <span>Next Billing Date</span>
              <span className="sm:hidden">:</span>
              <span className="font-semibold ml-1 sm:ml-0">Cancelled</span>
            </div>
            <div className="flex items-center flex-col-reverse sm:flex-row sm:justify-between my-6">
              <div>
                <ChangePlanLink isAppSubscription={isAppSubscription} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChangePlan;
